const TABLE_ROW_ACTION_SELECTOR = 'button, a, input, select, textarea, [role="button"]';

export const isTableRowActionTarget = (target: EventTarget | null) => (
  target instanceof Element && Boolean(target.closest(TABLE_ROW_ACTION_SELECTOR))
);
